/* DON'T EDIT THIS FILE: edit original and run build again */ import { useRealmHandler } from "../../framework/app-state/app-state-context.ts";
import {
  matchfinPaymentsAndSalesEmail,
  matchfinSupportEmail,
  matchfinSupportWhatsapp,
} from "../../framework/contact-information/matchfin-support.ts";
import { matchfinTenant } from "../../framework/tenant-matchfin-code/matchfin-tenant-code.ts";
import React, { useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";

export const SupportInfo = ({
  callToAction,
  displayPaymentsContact = false,
}: {
  displayPaymentsContact?: boolean;
  callToAction: string;
}): React.ReactNode => {
  const [show, setShow] = useState(false);
  const onHide = () => setShow(false);
  const realmHandler = useRealmHandler();
  if (realmHandler.getCode() !== matchfinTenant) {
    return null;
  }
  return (
    <>
      <Modal animation={false} centered show={show} onHide={onHide}>
        <div className="px-2">
          <Modal.Header>
            <Modal.Title>Contacto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Podés contactarte con el equipo de matchFin a través de los
            siguientes canales.
            <Table className="my-5" borderless>
              <tbody>
                <tr>
                  <th></th>
                  <th>Email</th>
                  <th>Whatsapp o teléfono</th>
                </tr>
                <tr>
                  <td>Soporte</td>
                  <td>
                    <a href={"mailto:" + matchfinSupportEmail}>
                      {matchfinSupportEmail}
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://api.whatsapp.com/send?phone=5491134550101"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {matchfinSupportWhatsapp}
                    </a>
                  </td>
                </tr>
                {displayPaymentsContact && (
                  <tr>
                    <td>Ventas</td>
                    <td>
                      <a href={"mailto:" + matchfinPaymentsAndSalesEmail}>
                        {matchfinPaymentsAndSalesEmail}
                      </a>
                    </td>
                    <td>-</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex flex-grow-1 justify-content-end">
              <Button variant="tertiary" onClick={onHide}>
                Cerrar
              </Button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
      <Button variant="link" onClick={() => setShow(true)}>
        {callToAction}
      </Button>
    </>
  );
};
